import { get } from "svelte/store";
import AllFilter from "../ShippingLanes.enums";
import ShippingLaneFilterType from "./ShippingLaneFilterType";
import ShippingLanesFiltersStore from "./Store";

export function initFilters(set) {
	set.flagFilters.set([AllFilter.ALL_FLAGS_READABLE, ...ShippingLanesFiltersStore.filters.flag]);
	set.shipTypeFilters.set([AllFilter.ALL_SHIPS_READABLE, ...ShippingLanesFiltersStore.filters.shipType]);
}

export function updateShippingLaneFilters(set, filterType, selectedFilter) {
	const customFilters = ShippingLanesFiltersStore.filters.custom;
	/** *
	 * If the selected filter is 'All flags', then we return the full list of shiptype filters,
	 * otherwise we must provide a list of available shiptypes from the custom filters available.
	 * We iterate over those, check which shiptypes are available for the selected flag and return an
	 * array made up of those. We add ALL_FLAGS back in at the end.
	 */

	if (filterType === ShippingLaneFilterType.FLAG) {
		if (selectedFilter === AllFilter.ALL_FLAGS_READABLE) {
			set.currentlySelectedFlag.set(AllFilter.ALL_FLAGS_READABLE);
			set.shipTypeFilters.set([AllFilter.ALL_SHIPS_READABLE, ...ShippingLanesFiltersStore.filters.shipType]);
		}
		else {
			set.currentlySelectedFlag.set(selectedFilter);
			const availableShipTypes = [];
			for (const customFilter of customFilters) {
				if (customFilter.flag.includes(selectedFilter)) {
					for (const shipType of customFilter.shiptype) {
						if (!availableShipTypes.includes(shipType)) {
							availableShipTypes.push(shipType);
						}
					}
				}
			}
			set.shipTypeFilters.set([AllFilter.ALL_SHIPS_READABLE, ...availableShipTypes]);
		}

		const currentShipTypeFilters = get(set.shipTypeFilters);
		const currentShipType = get(set.currentlySelectedShiptype);

		if (!currentShipTypeFilters.includes(currentShipType)) {
			set.currentlySelectedShiptype.set(AllFilter.ALL_SHIPS_READABLE);
		}
	}

	if (filterType === ShippingLaneFilterType.SHIP_TYPE) {
		if (selectedFilter === AllFilter.ALL_SHIPS_READABLE) {
			set.currentlySelectedShiptype.set(AllFilter.ALL_SHIPS_READABLE);
			set.flagFilters.set([AllFilter.ALL_FLAGS_READABLE, ...ShippingLanesFiltersStore.filters.flag]);
		}
		else {
			set.currentlySelectedShiptype.set(selectedFilter);
			const availableFlags = [];
			for (const customFilter of customFilters) {
				if (customFilter.shiptype.includes(selectedFilter)) {
					for (const flag of customFilter.flag) {
						if (!availableFlags.includes(flag)) {
							availableFlags.push(flag);
						}
					}
				}
			}
			set.flagFilters.set([AllFilter.ALL_FLAGS_READABLE, ...availableFlags]);
		}

		const currentFlagFilters = get(set.flagFilters);
		const currentFlag = get(set.currentlySelectedFlag);
		if (!currentFlagFilters.includes(currentFlag)) {
			set.currentlySelectedFlag.set(AllFilter.ALL_FLAGS_READABLE);
		}
	}
}
